import { render, staticRenderFns } from "./public-add-quiz.html?vue&type=template&id=5bd30ea4&scoped=true&"
import script from "./public-add-quiz.js?vue&type=script&lang=js&"
export * from "./public-add-quiz.js?vue&type=script&lang=js&"
import style0 from "./public-add-quiz.scss?vue&type=style&index=0&id=5bd30ea4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd30ea4",
  null
  
)

export default component.exports